import { render, staticRenderFns } from "./ShowProject.vue?vue&type=template&id=1898c65e"
import script from "./ShowProject.vue?vue&type=script&lang=js"
export * from "./ShowProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports